import {
  FREEFORM_TEMPLATE_EXAMPLES,
  FREEFORM_TEMPLATE_LIBRARY_EXAMPLES,
  SOAP_TEMPLATE_EXAMPLES,
  SOAP_TEMPLATE_LIBRARY_EXAMPLES,
} from "../constants";

export function useTemplateExamples() {
  const allSoapExamples = {
    ...SOAP_TEMPLATE_EXAMPLES,
    ...SOAP_TEMPLATE_LIBRARY_EXAMPLES,
  };

  const allFreeformExamples = {
    ...FREEFORM_TEMPLATE_EXAMPLES,
    ...FREEFORM_TEMPLATE_LIBRARY_EXAMPLES,
  };

  return {
    freeformExamples: FREEFORM_TEMPLATE_EXAMPLES,
    allSoapExamples,
    allFreeformExamples,
  };
}
